import { SettingsSection } from "./settings-section"
import { SettingsItem } from "./settings-item"
import { Button } from "../button"
import { User } from "lucide-react"

export function AccountPreferences() {
  return (      
    <SettingsSection title="Account Preferences" icon={User}>
      <SettingsItem
        title="Update Email"
        description="Change the email associated with your account."
        action={<Button className="bg-indigo-600 hover:bg-indigo-700">Update</Button>}
      />
      <SettingsItem
        title="Change Password"
        description="Keep your account secure with a new password."
        action={<Button className="bg-indigo-600 hover:bg-indigo-700">Change</Button>}
      />
    </SettingsSection>
  )
}
